module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_novel2.a7c49.png";